import { VStack } from '@chakra-ui/react';
import { iconByProduct } from 'features/subscriptions/utils';
import { ProductOption } from '../ProductOption';

export const ProductDropdown = ({
  availableProducts,
  handleProductSelect,
}: {
  availableProducts: string[];
  handleProductSelect: (productCode: string) => void;
}) => (
  <VStack spacing='2' align='stretch'>
    {availableProducts.map((productCode) => {
      const { name, iconUrl } = iconByProduct[productCode.toLowerCase()] ?? {};
      return (
        <ProductOption
          key={productCode}
          productCode={productCode}
          name={name}
          iconUrl={iconUrl}
          handleProductSelect={handleProductSelect}
        />
      );
    })}
  </VStack>
);
